import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	empty: {
		id: 'issue-navigator-action-pluggable-items.empty.empty',
		defaultMessage: 'There are no apps installed for the Issue Navigator',
		description:
			'No ecosystem apps that plug into the issue navigator are installed for this instance.',
	},
});

export default messages;
